<sc-flex vertical fitHeight stretchContent class="no-field-space transport-option-selection">
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.widgets.sac-client.transport-option-selection.title"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>
      <sc-padding>
        <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.driver"
          [scope]="data.transportScope"></app-transport-info-panel>

        <app-transport-options-panel [model]="model"></app-transport-options-panel>

        <div class="messages">
          <app-service-response [responseMessages]="data.responseMessages"></app-service-response>
        </div>
      </sc-padding>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
  <sc-actionbar [formGroup]="vehicleFormGroup">
    <sc-content-spacer grow></sc-content-spacer>
    <sc-checkbox-field labelDictionaryKey="tmc-yard.widgets.sac-client.transport-option-selection.use-as-vehicle" formControlName="useAsVehicle"></sc-checkbox-field>
    <sc-content-spacer></sc-content-spacer>
    <button mat-stroked-button class="cancel-button" (click)="cancelDialog()">
      <sc-dictionary-label dictionaryKey="shared.selection-dialog.action.cancel"></sc-dictionary-label>
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button (click)="confirm()" class="confirm-button" [disabled]="isConfirmDisabled">
      <sc-dictionary-label dictionaryKey="tmc-yard.widgets.sac-client.transport-option-selection.action.confirm"></sc-dictionary-label>
    </button>
  </sc-actionbar>
</sc-flex>
